module.exports = __webpack_public_path__ + "resources/img/main03_gov_m.4b3571f120fb37227bf436ed4e953214.png";